module.exports = __webpack_public_path__ + "img/control-button-icon-button-normal.97a3f208.svg";